import React, { useState, useEffect, useRef } from 'react';
import Analytics from '../../../utils/analytics';
import { Icon, IconButton, Link, Text, Flex } from '@homeexchange/design';
import i18n from '../../../i18n';
import styles from './legends.module.scss';
export var Legends = function () {
    var _a = useState(false), isPopupOpen = _a[0], setIsPopupOpen = _a[1];
    var popupRef = useRef(null);
    var togglePopup = function () {
        Analytics.trackGTM('SearchMap', {
            event_data: { action: 'click', text: 'legend', area: 'search_page_map' }
        });
        setIsPopupOpen(!isPopupOpen);
    };
    var closePopup = function () {
        setIsPopupOpen(false);
    };
    useEffect(function () {
        var handleClickOutside = function (event) {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                closePopup();
            }
        };
        if (isPopupOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isPopupOpen]);
    return (React.createElement("div", { className: styles['legends-button'] },
        !isPopupOpen && (React.createElement("button", { onClick: togglePopup, className: styles['legends-button-icon'] },
            React.createElement(Icon, { size: "large", name: "information-circle" }))),
        isPopupOpen && (React.createElement("div", { className: styles['legends-popup'], ref: popupRef },
            React.createElement(IconButton, { size: "small", icon: "remove", isBorderless: true, onClick: closePopup }),
            React.createElement("div", { className: styles['legends-list'] },
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement(Flex, { alignItems: "center", gap: "2" },
                            React.createElement(Icon, { name: "marker-home", size: "2xl" }),
                            React.createElement(Text, null, i18n.t('home:pin-legend-no-verified')))),
                    React.createElement("li", null,
                        React.createElement(Flex, { alignItems: "center", gap: "2" },
                            React.createElement(Icon, { name: "marker-home-favorite", size: "2xl" }),
                            React.createElement(Text, null, i18n.t('home:pin-legend-favorite-home')))),
                    React.createElement("li", null,
                        React.createElement(Flex, { alignItems: "center", gap: "2" },
                            React.createElement(Icon, { name: "marker-home-unavailable", size: "2xl" }),
                            React.createElement(Text, null, i18n.t('home:pin-legend-dual-no-verified')))),
                    React.createElement("li", null,
                        React.createElement(Flex, { alignItems: "center", gap: "2" },
                            React.createElement(Icon, { name: "marker-home-unavailable-favorite", size: "2xl" }),
                            React.createElement(Text, null, i18n.t('home:pin-legend-unavailable-favorite-home')))))),
            React.createElement(Link, { color: "primary", className: styles['legends-learn-more'] },
                React.createElement(Text, { size: "sm", dangerouslySetInnerHTML: {
                        __html: i18n.t('home:pin-legend-container-learn-more-link')
                    } }))))));
};
